export default "__VITE_ASSET__aafdcb67__"